const ActiveStatus = {
  INACTIVE: false,
  ACTIVE: true
};

export { ActiveStatus };
